import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './tufts-styled-text.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import tuftsListCssLit from '../tufts-list/tufts-list.css.lit';

/**
 * The Tufts Table component
 * @element tufts-styled-text
 *
 * @slot - a default slot
 */
@customElement('tufts-styled-text')
export class tuftsStyledText extends OutlineElement {
  static styles: CSSResultGroup = [
    componentStyles,
    tuftsHeadingCssLit,
    tuftsListCssLit,
  ];

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-styled-text': tuftsStyledText;
  }
}
